import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgMetricsOpticalSymmetry = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "currentColor",
	viewBox: "0 0 48 48",
	...props,
	children: /* @__PURE__ */ _jsx("switch", { children: /* @__PURE__ */ _jsxs("g", { children: [
		/* @__PURE__ */ _jsx("path", { d: "M22.687 31.48c-5.88-.206-13.38-3.995-17.487-10.553 4.107-6.558 11.606-10.347 17.487-10.553V5.232c-7.15.229-13.957 5.287-18.742 13.979L3 20.927l.945 1.714c4.785 8.694 11.592 13.752 18.742 13.981z" }),
		/* @__PURE__ */ _jsx("path", { d: "M22.687 12.999C18.4 13.26 15 16.81 15 21.163s3.399 7.903 7.687 8.164zm21.361 12.358c-4.823-8.694-11.683-13.752-18.89-13.979v5.142c5.927.205 13.486 3.993 17.626 10.553-4.14 6.56-11.699 10.349-17.626 10.554v5.142c7.206-.228 14.068-5.285 18.89-13.981L45 27.072z" }),
		/* @__PURE__ */ _jsx("path", { d: "M25.157 18.672v16.329c4.288-.261 7.687-3.811 7.687-8.164 0-4.354-3.399-7.904-7.687-8.165" })
	] }) })
});
export default SvgMetricsOpticalSymmetry;
